const getEstablishmentDefaultImage = (category?: string) => {
  switch (category) {
    case 'SPECIALIST':
      return '/images/accredited-establishments/details/item-specialist.png'
    case 'HOSPITAL':
      return '/images/accredited-establishments/details/item-hospital.png'
    case 'EMERGENCY_UNITY':
      return '/images/accredited-establishments/details/item-emergency-unity.png'
    case 'LABORATORY':
      return '/images/accredited-establishments/details/item-laboratory.png'
    case 'MATERNITY':
      return '/images/accredited-establishments/details/item-maternity.png'
    default:
      return '/images/accredited-establishments/details/item-specialist.png'
  }
}

export { getEstablishmentDefaultImage }
